// Captura de pantalla de la app (PNG en dataURL) para "Solicitar cambio".
//
// 1) Si existe window.electronAPI.capturarPagina() se usa (captura real de la
//    ventana, incluye todo lo que se ve).
// 2) Respaldo: html2canvas sobre el viewport actual.
//
// TODO(electron): exponer en el preload (NO implementado aqui, este repo solo
// tiene el frontend):
//
//   // preload.js
//   contextBridge.exposeInMainWorld("electronAPI", {
//     ...,
//     capturarPagina: () => ipcRenderer.invoke("capturar-pagina"),
//   });
//
//   // main.js
//   ipcMain.handle("capturar-pagina", async (event) => {
//     const win = BrowserWindow.fromWebContents(event.sender);
//     const image = await win.webContents.capturePage();
//     return image.toDataURL(); // "data:image/png;base64,..."
//   });

export const CLASE_CAPTURANDO = "sc-capturando";

const esperarFrames = (n = 2) =>
  new Promise((resolve) => {
    const paso = (i) => (i <= 0 ? resolve() : requestAnimationFrame(() => paso(i - 1)));
    paso(n);
  });

const esperar = (ms) => new Promise((r) => setTimeout(r, ms));

// Cierra popovers/dropdowns/tooltips abiertos. antd cierra los popovers de
// click con un mousedown fuera de ellos; lo que aun quede en el DOM se oculta
// con la clase CLASE_CAPTURANDO (ver solicitarCambio.css).
function cerrarFlotantes() {
  if (document.activeElement && typeof document.activeElement.blur === "function") {
    document.activeElement.blur();
  }
  document.body.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true }));
}

async function capturarConHtml2Canvas() {
  const { default: html2canvas } = await import("html2canvas");
  const canvas = await html2canvas(document.documentElement, {
    x: window.scrollX,
    y: window.scrollY,
    width: window.innerWidth,
    height: window.innerHeight,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    scale: Math.min(window.devicePixelRatio || 1, 2),
    useCORS: true,
    logging: false,
    backgroundColor: "#ffffff",
  });
  return canvas.toDataURL("image/png");
}

/**
 * Devuelve la captura como dataURL PNG. Oculta temporalmente popovers y el
 * boton "Solicitar cambio" (clase CLASE_CAPTURANDO en <html>) y la retira al
 * terminar, haya error o no. Lanza si ningun metodo pudo capturar.
 */
export async function capturarPantalla() {
  const root = document.documentElement;
  root.classList.add(CLASE_CAPTURANDO);
  try {
    cerrarFlotantes();
    await esperarFrames(2);
    await esperar(260); // animacion de salida de antd

    if (typeof window.electronAPI?.capturarPagina === "function") {
      const dataUrl = await window.electronAPI.capturarPagina();
      if (dataUrl) return dataUrl;
    }
    return await capturarConHtml2Canvas();
  } finally {
    root.classList.remove(CLASE_CAPTURANDO);
  }
}

export async function dataUrlABlob(dataUrl) {
  const res = await fetch(dataUrl);
  return res.blob();
}
